import { Box, Button, Dialog, DialogContent, DialogProps, MobileStepper, Paper, Typography } from '@mui/material';
import { Icon } from 'components/icon';
import React from 'react';
import { theme } from '/config'
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface IModalProps extends DialogProps {
  title?:  string,
  open:    boolean,
  onClose: () => void | Promise<void>,
}

export const WalkthroughModal: React.FC<IModalProps> = ({
  title,
  open,
  onClose,
  children,
  ...props
}) => {
  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const { t } = useTranslation();

  const steps = [
    {
      label: t('introduction'),
      description: t('charts_walkthrough_intro'),
      image: <img width='auto' height='240px' src={require('assets/images/chart_intro.jpg')}/>,
      flexDirection: 'column-reverse',
    },
    {
      label: t('introduction'),
      description: t('charts_walkthrough_backbutton'),
      image: <img width='auto' height='300px' src={require('assets/images/chart_intro_backArrow.jpg')}/>,
      flexDirection: 'row-reverse',
    },
    {
      label: t('attempts_chart'),
      description: t('attempts_chart_description'),
      image: <img width='auto' height='300px' src={require('assets/images/chart_attempts.jpg')}/>,
      flexDirection: 'row-reverse',
    },
    {
      label: t('time_chart'),
      description: t('time_chart_description'),
      image: <img width='540px' height='300px' src={require('assets/images/time_chart.jpg')}/>,
      flexDirection: 'row-reverse',
    },
    {
      label: t('status_chart'),
      description: t('status_chart_description'),
      image: <img width='auto' height='300px' src={require('assets/images/chart_status.jpg')}/>,
      flexDirection: 'row-reverse',
    },
    {
      label: t('filter_options'),
      description: t('filter_options_description'),
      image: <img width='540px' height='auto' src={require('assets/images/filter_options.jpg')}/>,
      flexDirection: 'row-reverse',
    }, {
      label: t('export_options'),
      description: t('export_options_description'),
      image: <img width='540px' height='auto' src={require('assets/images/export_options.jpg')}/>,
      flexDirection: 'row-reverse',
    },
  ];

  const maxSteps = steps.length;
  
  return (
    <StyledModal
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth='md'
      PaperProps={{
        elevation: 0,
      }}
      {...props}
    >
      <Box sx={{cursor: 'pointer' , marginLeft: 'auto'}} >
        <Icon size='size-16' iconId = 'remove' onClick={onClose} />
      </Box>
        <Typography variant='h5'>{steps[activeStep].label}</Typography>
      <DialogContent sx={{p: 1}}>
        <Paper color={theme.palette.white.main} sx={{width: '100%', flexGrow: 1, mb: 2,  display: 'flex', justifyContent: 'center'}}>
      <Box padding={2} sx={{ display: 'flex', flexDirection: `${steps[activeStep].flexDirection}`, gap: 2, height: '36rem'}}>
        <Box sx={{overflow: 'auto'}} flex='2'>
          <Typography fontSize='18px'>{steps[activeStep].description}</Typography>
        </Box>
        {steps[activeStep].image &&
        <Box alignItems='center' flex='1'>
          {steps[activeStep].image}
        </Box>
        }
      </Box>
      </Paper>
      <MobileStepper
        variant="text"
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            variant='text'
            size='small'
            color='secondary'
            endIcon={<Icon size='size-16' iconId='arrow-right'/>}
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            {t('next')}
          </Button>
        }
        backButton={
          <Button 
            variant='text' 
            size='small' 
            color='secondary'
            startIcon={<Icon size='size-16' iconId='chevron-left'/>} 
            onClick={handleBack} 
            disabled={activeStep === 0}>
            {t('back')}
          </Button>
        }
      />
      </DialogContent>
    </StyledModal>
  )
}


const StyledModal = styled(Dialog)`
  .MuiDialogContent-root {
    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`

